import styled, { css } from 'styled-components';
import { Divider1, FlexContainer, StyledBox, StyledTypography, VerticalFlexContainer } from 'styles/common';

import { CheckIcon, StyledIcon } from 'constants/icons';
import theme, { greenColorWithOpacity } from 'constants/theme';

const CircularIcon = styled(StyledIcon)`
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border: 1px solid #eeeeee;
  padding: 1rem;
  ${(props) =>
    props.backgroundColor &&
    css`
      background-color: ${props.backgroundColor};
    `};
`;

const Wrapper = styled(VerticalFlexContainer)`
  flex-grow: 1;
  background: white;
  padding: 1rem;
`;

const CursorStyledTypography = styled(StyledTypography)`
  cursor: pointer;
`;

function SubmissionMessage({ onViewInstanceDetails }) {
  return (
    <Wrapper>
      <VerticalFlexContainer alignitems="stretch" justifycontent="space-between" flexgrow={1}>
        <VerticalFlexContainer alignitems="center" topGutter={8} style={{ height: 'auto' }}>
          <CircularIcon
            backgroundColor={greenColorWithOpacity(0.3)}
            color={greenColorWithOpacity(1)}
            size="smaller"
            bottomGutter={4}
          >
            <CheckIcon />
          </CircularIcon>

          <StyledTypography bottomGutter={1} variant="h4" weight={600} color={greenColorWithOpacity(1)}>
            Thank you,
          </StyledTypography>
          <StyledTypography bottomGutter={1} variant="h6" weight={600} color="textSecondary">
            Your 1:1 has been submitted
          </StyledTypography>

          <Divider1 topGutter={8} />
        </VerticalFlexContainer>

        {/* --------------  submitted - view submission */}
        <FlexContainer>
          <StyledBox
            flexgrow={1}
            bgcolor={theme.palette.background.grey}
            bottomGutter={4}
            leftGutter={2}
            rightGutter={2}
            flexcontainer
            flexdirection="column"
            alignitems="center"
            style={{ width: '95%' }}
          >
            <StyledTypography bottomGutter={1} topGutter={3} variant="body2" weight={600}>
              Please check this page after your manager has submitted his feedback
            </StyledTypography>
            <StyledTypography bottomGutter={2} variant="body2" weight={600}>
              You need to accept the feedback to complete this 1:1
            </StyledTypography>

            <CursorStyledTypography
              variant="body2"
              weight={600}
              color="primary"
              bottomGutter={3}
              onClick={onViewInstanceDetails}
            >
              View Submission
            </CursorStyledTypography>
          </StyledBox>
        </FlexContainer>
      </VerticalFlexContainer>
    </Wrapper>
  );
}

export default SubmissionMessage;
